import { render, staticRenderFns } from "./EditDeathInfo.vue?vue&type=template&id=c99e8556"
import script from "./EditDeathInfo.vue?vue&type=script&lang=js"
export * from "./EditDeathInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports